
import Page from "shared/components/Page"
import ProfileContainer from "./ProfileContainer"
import { InputText } from "primereact/inputtext"
import CustomGrid from "shared/components/CustomGrid"
import CustomCard from "shared/components/CustomCard"
import CustomForm from "shared/components/CustomForm"
import { CustomFileInput, CustomInput, CustomTextArea } from "shared/components/allInput"
import UserImg from "assets/images/usernew.png";
import CustomButton, { Buttonlayout, CustomButtonOutlined } from "shared/components/inputButton"
import { ProfilePicViewInput } from "shared/components/AllViewInputs"
import AddSocialLinkTable from "shared/Tables/AddSocialLinkTable"
import { useNavigate } from "react-router-dom"
const EditProfile = () => {
    const {
        data,
        socialLinks,
        setSocialLinks,
        handleChange,
        onsubmit,
        loading,
        setLoading,
    } = ProfileContainer()
    const navigate = useNavigate()
    return (
        <Page>
            <div className="flex gap-6">
                <div className="profile-left">
                    {
                        typeof data?.profilePicture == "object" ? <ProfilePicViewInput file={data?.profilePicture} name="profilePicture" /> : <ProfilePicViewInput src={data?.profilePicture} name="profilePicture" />
                    }
                    <CustomFileInput
                        name="profilePicture"
                        data={data}
                        onChange={(event) => {
                            const file = event.target.files[0];
                            handleChange({ name: "profilePicture", value: file })
                        }}
                        col={12}
                        ignoreLabel
                    />
                </div>
                <div className="profile-right">
                    <CustomForm>
                        <CustomInput
                            name="fullName"
                            data={data}
                            onChange={handleChange}
                        />
                        <CustomInput
                            name="category"
                            data={data}
                            onChange={handleChange}
                        />
                        <CustomInput
                            name="distributor"
                            data={data}
                            onChange={handleChange}
                            label={"Label/Distribution"}
                        />
                        <CustomInput
                            name="publisher"
                            data={data}
                            onChange={handleChange}
                        />
                        <CustomTextArea
                            col={12}
                            name="aboutMe"
                            data={data}
                            onChange={handleChange}
                        />
                    </CustomForm>
                    <AddSocialLinkTable title={"Social"} allValues={socialLinks} setAllValues={setSocialLinks} />
                </div>
            </div>
            <Buttonlayout>
                <CustomButtonOutlined label={"Cancel"} onClick={() => navigate("/profile")} />
                <CustomButton label={"Save"} onClick={onsubmit} loading={loading} />
            </Buttonlayout>
        </Page>
    )
}

export default EditProfile